/* vbPerms.js — نمایان/فعال بودن تب‌ها و دکمه‌ها از سرور
   همهٔ قاعده‌ها در سرور حساب می‌شود (auth_app/vb_access.py)، همان قاعده‌ای که
   API ها را کنترل می‌کند. تا جواب نیامده یا اگر خطا شد، همه‌چیز بسته است. */
import { useEffect, useState } from 'react';

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });

let menuCache = { token: null, data: null, promise: null };

export function loadVbMenu() {
  const token = localStorage.getItem('access');
  if (menuCache.token === token && menuCache.data) return Promise.resolve(menuCache.data);
  if (menuCache.token === token && menuCache.promise) return menuCache.promise;
  menuCache = { token, data: null, promise: null };
  menuCache.promise = fetch('/api/auth/ui/menu/', { headers: auth() })
    .then(r => r.json())
    .then(d => {
      const data = d && d.ok ? d.tabs : {};
      if (menuCache.token === token) menuCache.data = data;
      return data;
    })
    .catch(() => ({}));
  return menuCache.promise;
}

/** {TBXXX: {visible, buttons:{BTNYYY: bool}}} — تا بارگذاری null */
export function useVbMenu() {
  const [menu, setMenu] = useState(menuCache.data);
  useEffect(() => {
    let alive = true;
    loadVbMenu().then(m => { if (alive) setMenu(m); });
    return () => { alive = false; };
  }, []);
  return menu;
}

/** آیا تب دیده می‌شود (فقط سطر صریح، حتی برای دسترسی کامل) */
export const tabVisible = (menu, tab) => !!(menu && menu[tab] && menu[tab].visible);

/** دکمهٔ تب فعال است؟  key = کلید دکمه در جدول مجوز */
export const tabButtonOn = (menu, tab, key) =>
  !!(menu && menu[tab] && menu[tab].visible && menu[tab].buttons
     && menu[tab].buttons[String(key || '').toUpperCase()]);

/**
 * دکمه‌های یک فرم: const fb = useFormButtons('FRMZEMANAT', ['BTNNEW','BTNEDIT','BTNDELETE'])
 * fb.can('BTNNEW') → bool   ،  fb.open → فرم باز می‌شود یا نه  ، fb.loaded
 */
export function useFormButtons(form, buttons) {
  const key = `${form}|${(buttons || []).join(',')}`;
  const [state, setState] = useState({ loaded: false, open: false, buttons: {} });
  useEffect(() => {
    let alive = true;
    const q = `form=${encodeURIComponent(form)}&buttons=${encodeURIComponent((buttons || []).join(','))}`;
    fetch(`/api/auth/ui/form/?${q}`, { headers: auth() })
      .then(r => r.json())
      .then(d => { if (alive) setState(d && d.ok ? { loaded: true, open: !!d.open, buttons: d.buttons || {} }
                                                  : { loaded: true, open: false, buttons: {} }); })
      .catch(() => { if (alive) setState({ loaded: true, open: false, buttons: {} }); });
    return () => { alive = false; };
  }, [key]);
  return {
    ...state,
    can: (btn) => !!state.buttons[String(btn || '').toUpperCase()],
  };
}
